import React from "react";
import logo from "../../assets/images/logo.svg";

import "./Header.css";

const Header = () => {

  return (
    <div className="header-wrapper">
      <img src={logo} alt={"se-logo"} width={180} />
      <hr />
    </div>
  );
};

export default Header;
